import React from "react";
import logoImg from "assets/logo.svg";

const Footer = () => {
    return (
        <footer role="contentinfo">
            <p>
                I'm not a licensed doctor, always consult a doctor before doing
                drastic life changes{" "}
            </p>
            <p>This webpage was created as part of a school project.</p>
            <img src={logoImg} alt="logo" title="logo" className="logo" />
        </footer>
    );
};

export default Footer;
